export default "__VITE_ASSET__c836e9f6__"